import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tnFormat'
})
export class TnFormatPipe implements PipeTransform {

    transform(tn: string, countryCodeLength?: number): any {
        if (!tn) { return ''; }
        if (countryCodeLength && countryCodeLength > 0) {
            // Bell international: bracket only the country code, format the rest
            const cc = tn.substr(0, countryCodeLength);
            const local = tn.substr(countryCodeLength);
            const localFormatted = local.length >= 10
                ? local.substr(0, local.length - 7) + '-' + local.substr(-7, 3) + '-' + local.substr(-4, 4)
                : local;
            return '(' + cc + ') ' + localFormatted;
        }
        if (tn.length > 10) {
            return '(' + tn.substr(0, tn.length - 10) + ') ' + tn.substr(-10, 3) + '-' + tn.substr(-7, 3) + '-' + tn.substr(-4, 4);
        } else {
            return tn.substr(0, 3) + '-' + tn.substr(3, 3) + '-' + tn.substr(6, 4);
        }
    }

}
